export const SELECT_ORDER_DETAILS_TABLE_ID = 35;
